<div [ngClass]="['Pricing_card_wrapper', 'text-center', 'color-' + color]">
  <div class="Pricing_card_wrapper_header">
    <fa-icon [icon]="iconName" size="4x"></fa-icon>
    <h3>{{ title }}</h3>
  </div>
  <div class="Pricing_card_wrapper_info" *ngIf="info">
    <p class="Pricing_card_wrapper_info_title" *ngIf="info.title">
      {{ info.title }}
    </p>
    <p class="Pricing_card_wrapper_info_subtitle" *ngIf="info.subtitle">
      {{ info.subtitle }}
    </p>
    <p class="Pricing_card_wrapper_info_extra" *ngIf="info.extra">
      {{ info.extra }}
    </p>
  </div>
  <div class="Pricing_card_wrapper_body" *ngIf="text">
    <p>{{ text }}</p>
  </div>

  <div
    class="Pricing_card_wrapper_footer d-flex justify-content-center"
    *ngIf="buttons.length > 0">
    <app-button
      *ngFor="let button of buttons"
      [route]="button.route"
      [text]="button.text"
      [Click]="button.onClick"
      [color]="button.color"
      [size]="button.size"></app-button>
  </div>
</div>
